import { createFileRoute, redirect } from '@tanstack/react-router'

// The standalone jobs list merged into the Updates page ("Recent activity").
// Keep the old URL working for bookmarks; the job detail route stays.
export const Route = createFileRoute('/_app/jobs/')({
  beforeLoad: () => {
    throw redirect({ to: '/sync' })
  },
})
